import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';

const ConfirmationModal = ({ title, onSubmit, onClose, type }) => {
	return (
		<ModalContainer
			onCloseModal={onClose}
			dialogClassName={`${
				type === 'review' ? 'review-modal' : type === 'CANCEL' ? 'cancel-modal' : 'save-modal'
			}`}
		>
			<div className="common-popup arrange-category-modal shadow-24dp">
				<div className="common-popup-body">
					<p className="regular-14">{title}</p>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button
							className={`button ${
								type === 'REVIEW'
									? 'approve'
									: ['CANCEL', 'SAVE', 'FORCE_SAVE', 'FORCE_UNIT_SAVE'].includes(type)
										? 'revise'
										: ''
							} size32 ml-2`}
							onClick={() => {
								if (['REVIEW', 'CANCEL'].includes(type)) {
									onSubmit('YES');
								} else {
									onSubmit('NO');
								}
							}}
						>
							{type === 'REVIEW' ? 'Approve' : type === 'CANCEL' ? 'Yes' : 'No'}
						</button>
						<button
							className={`button ${type === 'REVIEW' ? 'revise' : ''} size32 ml-2`}
							onClick={() => {
								if (['SAVE', 'FORCE_SAVE', 'FORCE_UNIT_SAVE'].includes(type)) {
									onSubmit('YES');
								} else {
									onSubmit('NO');
								}
							}}
						>
							{type === 'REVIEW'
								? 'Reject'
								: ['SAVE', 'FORCE_SAVE', 'FORCE_UNIT_SAVE'].includes(type)
									? 'Yes'
									: 'No'}
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default ConfirmationModal;
